import React from 'react';
import styled from "styled-components";


const FilteredHeader = styled.div`
    margin-bottom: 2rem;
    font-family: "Poppins", sans-serif;
    padding: 1rem;
    background-color: #f0f0f0;
    border-radius: 5px;
    font-size: 0.75rem;
    .tag-pill {
        background-color: #2c5530;
        color: white;
        font-weight: bold;
        padding: 4px 8px;
        border-radius: 4px;
        text-decoration: none;
        display: inline-block;
    }
    .clear-filter {
        float: right;
        font-size: 0.75rem;
        text-decoration: none;
    }
    h4 {
        font-size: 1rem;
        font-family: "Roboto slab", serif;
        font-weight: bold;
        color: #2c5530;
    }
    
    
`;

export const FilteredListHeader = ({title, clearFilterLink, tagLabel}) => {
    return (
        <FilteredHeader>
            <div className="clear-filter"><a href={clearFilterLink}>Clear filter</a></div>
            <h4>{title}</h4>
            <div className="tag-pill">{tagLabel}</div>
        </FilteredHeader>
    );
};